import { render } from "./AvisoServiciosPublicos.vue?vue&type=template&id=575bb9ca&scoped=true"
import script from "./AvisoServiciosPublicos.vue?vue&type=script&lang=js"
export * from "./AvisoServiciosPublicos.vue?vue&type=script&lang=js"

import "./AvisoServiciosPublicos.vue?vue&type=style&index=0&id=575bb9ca&scoped=true&lang=css"

import exportComponent from "/home/runner/work/jeanInformatico-management-system/jeanInformatico-management-system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-575bb9ca"]])

export default __exports__